import * as React from "react";
import {useRef, useState} from "react";
import {renderToString} from 'react-dom/server'
import videojs from "video.js";
import overlay from "videojs-overlay"
import Papaparse from "papaparse";
import {Link, navigate} from "gatsby";
import {Config, posterImages, RaumVideos} from "./vars";

let videoPlayer, audioPlayer;
let largeOverlays = [];
let allImages = {};
let currentOverlayPreviewId = null;

const IMAGES_PATH = '/images/overlays/';
const MOBILE_BREAKPOINT_WIDTH = 800;
const VIDEO_WIDTH = 1920;
const VIDEO_HEIGHT = 1080;

/**
 *
 * @returns {boolean}
 */
const isMobile = () => {
    if (!Config.isTerminal && typeof window !== `undefined`) {
        return window.innerWidth < MOBILE_BREAKPOINT_WIDTH;
    }
    return false;
}

/**
 *
 * @param event
 */
const clickOverlayLink = (event) => {

    const overlayLink = event.target.closest('.overlay-link');
    const id = overlayLink.getAttribute('data-overlayid');
    if (id === null) {
        return;
    }
    const raum = overlayLink.getAttribute('data-raum');

    const ModalDialog = videojs.getComponent('ModalDialog');
    let contentElement = document.createElement('div');
    contentElement.innerHTML = largeOverlays[id];
    contentElement.className = 'vjs-overlay vjs-overlay-top vjs-overlay-background overlay-' + raum + '-' + id;

    const modal = new ModalDialog(videoPlayer, {
        content: contentElement,
        temporary: false
    });

    const setCloseButtonPosition = () => {
        const contentRect = contentElement.getBoundingClientRect();
        document.querySelectorAll('.vjs-close-button').forEach((button) => {
            button.style.top = (contentRect.top + 15) + 'px';
            button.style.right = 0;
            button.style.position = 'fixed';
            button.style.left = (contentRect.left + contentRect.width - button.getBoundingClientRect().width - 20) + 'px';
        });
    }

    if (typeof window !== `undefined`) {
        setTimeout(() => {
            setCloseButtonPosition();
        });

        window.addEventListener('resize', setCloseButtonPosition);
    }

    modal.on('modalopen', function () {
        pause();
    });

    modal.on('modalclose', function () {
        window.removeEventListener('resize', setCloseButtonPosition);

        if (audioPlayer !== undefined && !videoPlayer.paused()) {
            audioPlayer.pause();
        }
    });

    videoPlayer.addChild(modal);
    modal.open();
}

/**
 *
 */
const setPlayerSize = (player) => {
    if (typeof window !== `undefined`) {
        player = player === undefined ? videoPlayer : player;
        const size = getVideoSize();
        if (size.height !== null) {
            player.width(size.width);
            player.height(size.height);

            if (document.getElementById('video')) {
                const videoRect = document.getElementById('video').getBoundingClientRect();
                const watermarks = document.getElementById('watermarks');
                watermarks.style.width = videoRect.width + 'px';
                watermarks.style.left = videoRect.left + 'px';
            }
        }
    }
}

/**
 *
 * @returns {{width: null, height: null}}
 */
const getVideoSize = () => {
    const container = document.getElementById('video-wrap').getBoundingClientRect();

    const size = {
        width: null,
        height: null
    };

    if (typeof window !== `undefined`) {
        let height = container.width * (VIDEO_HEIGHT / VIDEO_WIDTH);
        if (window.innerHeight < height) {
            size.width = parseInt(window.innerHeight * (VIDEO_WIDTH / VIDEO_HEIGHT));
            size.height = window.innerHeight;
        } else {
            size.width = container.width;
            size.height = height;
        }
    }

    return size;
}

/**
 *
 */
const updatePreviews = () => {
    const visible = document.querySelectorAll('#videoBox .blt-overlay-preview:not(.vjs-hidden)');
    const curent = visible[visible.length - 1];
    const PREVIEW_BOTTOM = 10;

    if (curent) {
        const curId = parseInt(curent.firstChild.getAttribute('data-overlayid'));

        if (currentOverlayPreviewId === curId) {
            return;
        }

        currentOverlayPreviewId = curId;
        curent.setAttribute('data-pos', curId);
        curent.style.bottom = PREVIEW_BOTTOM + 'px';

        document.querySelectorAll('#videoBox .blt-overlay-preview').forEach((el) => {
            const id = parseInt(el.getAttribute('data-pos'));
            const nextEl = document.querySelector('[data-pos="' + (id + 1) + '"]');
            const add = nextEl === null ? 0 : (nextEl.getBoundingClientRect().height - 100);
            el.style.bottom = ((curId - id) * 70 + (PREVIEW_BOTTOM + 10) + add) + 'px';
            if (id < curId) {
                el.style.bottom = ((curId - id) * 70 + (PREVIEW_BOTTOM + 10) + add) + 'px';

                if (curId - id > 2) {
                    el.style.opacity = '0';
                    setTimeout(() => {
                        if (!el.classList.contains('show-all')) {
                            el.classList.add('vjs-hidden')
                            el.removeAttribute('style');
                        }
                    }, 2000);
                }
            } else {
                el.style.bottom = (PREVIEW_BOTTOM + 10) + 'px';
            }
        });

    }

}

/**
 *
 */
const addVideoContainer = () => {
    const wrap = document.getElementById('video-wrap');
    let video = document.getElementById('video');

    if (wrap === null || video !== null) {
        return;
    }

    video = document.createElement('video');
    video.setAttribute('id', 'video');
    video.classList.add('video-js');
    video.classList.add('vjs-big-play-centered');
    wrap.appendChild(video);
}

/**
 *
 * @param text
 * @returns {*}
 */
const normalize = (text) => {
    return text.replace(/[\r\n]/g, '<br/>');
}

/**
 *
 */
const init = (raum, closeVideo, data) => {

    require("@aleexxx/videojs-markers");

    if (audioPlayer === null || audioPlayer === undefined) {
        audioPlayer = document.getElementById('audioPlayer');
        audioPlayer.volume = 1;
    }

    if (videoPlayer !== undefined) {
        videoPlayer.dispose();
    }

    addVideoContainer();

    videojs.registerPlugin('overlay', overlay);
    videojs.hook('setup', () => {
        if (document.getElementById('video') !== null) {
            document.getElementById('video').classList.remove('vjs-hidden');
        }
    });

    let controlBar = {};
    let userActions = {};

    if (Config.isTerminal) {
        controlBar = {
            fullscreenToggle: false,
            pictureInPictureToggle: false,
            playToggle: false,
            captionsButton: false,
            chaptersButton: false,
            subtitlesButton: false,
            progressControl: {seekBar: true},
        };

        userActions = {
            doubleClick: false
        };
    }

    videoPlayer = videojs(
        'video',
        {
            controlBar: controlBar,
            userActions: userActions,
            controls: true,
            preload: 'auto',
            loadingSpinner: true,
            bigPlayButton: true,
            loop: false,
            poster: renderToString(Config.prefix + posterImages[raum])
        },
        function onPlayerReady() {
            setPlayerSize(this);
            this.volume(0.5);
            this.bigPlayButton.on('click', function (event) {
                initOverlays(raum, data);
            })

            this.on('timeupdate', function () {
                updatePreviews();
            });

            this.on('fullscreenchange', () => {
                const watermarks = document.getElementById('watermarks');
                if (this.isFullscreen()) {
                    document.getElementById('video_html5_api').after(watermarks);
                } else {
                    document.getElementById('video').before(watermarks);
                }
            });

            this.on('ended', () => {
                stop();
                if (data === null || data.length < 1) {
                    closeVideo();
                } else {
                    this.hasStarted(false);
                    this.currentTime(0);
                    this.bigPlayButton.show();
                    showAllPreviews();
                }
            });
        }
    );

    if (typeof window !== `undefined`) {
        window.addEventListener('resize', () => {
            setPlayerSize(videoPlayer)
        });
    }

    videoPlayer.src({
        src: Config.prefix + '/video/' + (isMobile() ? 'mobile/' : '') + RaumVideos[raum],
        type: "video/mp4"
    });

    return initOverlays(raum, data);
}

/**
 *
 * @param data
 */
const setAllImages = (data) => {
    data.forEach((row) => {
        allImages[row.node.fluid.originalName] = row.node;
    })
}

/**
 *
 * @param data
 * @returns {*}
 */
const initOverlays = (raum, data) => {
    if (data === null || data === undefined || data.length < 1) {
        return videoPlayer;
    }

    if (audioPlayer !== undefined) {
        audioPlayer.pause();
    }

    let smallOverlays = [];
    largeOverlays = [];
    let markers = [];

    let overlayData = {};

    data.forEach((row, index) => {

        if (row['startzeit-preview'] === "") {
            return;
        }

        const time = row['startzeit-preview'].split(':');
        let startTime
        if (time.length === 2) {
            startTime = parseInt(time[0]) * 60 + parseInt(time[1]);
        } else {
            startTime = parseInt(time[1]) * 60 + parseInt(time[2]);
        }

        let text = normalize(row['text overlay']).trim();

        const links = text.match(/(https:[^\s'"]*)/ig);
        if (links !== null) {
            links.forEach((link) => {
                if (Config.isTerminal) {
                    text = text.replaceAll(link, '');
                } else if (text.match(/<\/a>/) === null) {
                    text = text.replaceAll(link, '<a href="' + link + '" target="_blank">' + link + '</a>');
                }
            });
        }

        if (Config.isTerminal) {
            text = text.replaceAll(/<a /g, '<span ').replaceAll(/<\/a>/g, '</span>');
        }

        const images = [];

        const imageOverlay = row['image overlay'].split('\n');
        imageOverlay.forEach((img, index) => {

            let imageLabel = (null);

            if (index === imageOverlay.length - 1) {
                imageLabel = (row['image label'] === undefined || row['image label'] === '')
                    ? (null)
                    : (
                        <div key={'label' + index} dangerouslySetInnerHTML={{__html: row['image label']}}/>
                    );
            }

            if (img.trim() !== '') {
                if (allImages[img + '.jpg'] === undefined) {
                    return;
                }
                const image = allImages[img + '.jpg'];
                const source = image.gatsbyImageData.images.sources[0];
                images.push((
                    <>
                        <picture key={index} className="overlay-layer-image">
                            <source type={source.type} srcSet={source.srcSet} sizes={source.sizes}/>
                            <img style={{objectFit: "cover", "opacity": 1}}
                                 sizes={source.sizes} srcSet={source.srcSet} alt="" className="overlay-layer-image"
                                 decoding="async"/>
                        </picture>
                        {imageLabel}
                    </>
                ))
            }
        });

        let overlay = '';

        if (text !== '' || images.length > 0) {
            overlay = renderToString(
                <div className={"overlay-row overlay-row-" + index}>
                    <div className="col-img">
                        {images}
                    </div>
                    <div className="col-text" dangerouslySetInnerHTML={{__html: text}}/>
                </div>
            );
        }

        if (overlayData[startTime] === undefined) {
            overlayData[startTime] = {
                preview: {
                    'image': row['image preview'].trim(),
                    'text': normalize(row['text preview']),
                    'start': startTime,
                    'end': row['endzeit-preview'],
                },
                overlay: overlay
            };
        } else {
            overlayData[startTime]['overlay'] += overlay;
        }
    });

    Object.keys(overlayData).forEach((key, index) => {

        const overlay = overlayData[key];
        markers.push({
            time: overlay['preview']['start'] - 0.2,
            text: overlay['preview']['text']
        });

        //const endTime = data[index + 2] !== undefined ? parseInt(data[index + 2].start) : 'custom2';
        const endTime = 'custom2';
        smallOverlays.push({
            start: overlay['preview']['start'],
            end: endTime,
            class: 'blt-overlay-preview',
            align: 'bottom-left',
            content: renderToString(
                <span className="overlay-link" data-overlayid={index} data-raum={raum}>
                    {overlay['preview']['image']
                        ?
                        <figure>
                            <img src={Config.prefix + IMAGES_PATH + overlay['preview']['image'] + '.jpg'} alt=""
                                 className="overlay-image"/>
                        </figure>
                        : ''
                    }
                    <span dangerouslySetInnerHTML={{__html: overlay['preview']['text']}}/>
                </span>
            )
        });
        largeOverlays.push(overlay['overlay']);
    });

    videoPlayer.overlay({
        content: 'Default overlay content',
        overlays: smallOverlays
    });

    if (typeof videoPlayer.markers.getMarkers === "undefined") {
        videoPlayer.markers({
            markerStyle: {
                'background-image': 'url("' + Config.prefix + '/images/rhombus.png")',
                'background-position': '0 0',
                'background-size': '14px 29px',
                'background-color': 'transparent',
                'width': '14px',
                'height': '29px'
            },
            markerTip: {
                text: (marker) => {
                    return marker.text;
                }
            },
            time: null,
            markers: markers
        })
    }

    document.querySelectorAll('#video-wrap .overlay-link').forEach((el) => {
        el.addEventListener('click', clickOverlayLink);
    })

    return videoPlayer;
}

/**
 *
 * @param filename
 * @returns {Promise<*>}
 */
const fetchOverlays = async (filename) => {
    const response = await fetch(filename);
    let csv = await response.text();
    if (response.status !== 200) {
        return null;
    }
    const results = Papaparse.parse(csv, {
        header: true,
        skipEmptyLines: true,
        transformHeader: (header) => {
            return header.trim();
        },
        transform: (value) => {
            return value.trim()
        }
    });
    return results.data;
}

/**
 *
 * @param raum
 */
const setOverlays = async (raum, closeVideo, callback) => {
    await fetchOverlays(Config.prefix + "/overlays/" + raum + ".csv").then((data) => {
        init(raum, closeVideo, data);
        play();
        if (typeof callback === 'function') {
            callback();
        }
    })
}

/**
 *
 * @param raum
 * @returns {JSX.Element}
 * @constructor
 */
const Container = ({raum, children}) => {

    const wrapClicked = (event) => {
        if (event.target.classList.contains('vjs-poster')) {
            replay();
        }
    }

    return (
        <>
            {/* eslint-disable jsx-a11y/media-has-caption */}
            <div id="video-wrap" onClick={wrapClicked} onKeyPress={wrapClicked} role="button" tabIndex="0">
                <div id="watermarks">{children}</div>
            </div>
            {/* eslint-enable jsx-a11y/media-has-caption */}
        </>
    );
}

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
const Intro = () => {

    let player = useRef(null);
    const [muteClassName, setMuteClassName] = useState('mute');

    React.useEffect(() => {

        let controlBar = {
            fullscreenToggle: true,
            pictureInPictureToggle: false,
            playToggle: true,
            captionsButton: false,
            muteButton: false,
            chaptersButton: false,
            subtitlesButton: false,
            progressControl: {seekBar: true},
        };
        let userActions = {};

        if (Config.isTerminal) {
            controlBar['playToggle'] = false;
            userActions = {
                doubleClick: false
            };
        }

        player.current = videojs(
            'videoIntro',
            {
                controlBar: controlBar,
                userActions: userActions,
                controls: true,
                preload: 'auto',
                loadingSpinner: true,
                bigPlayButton: true,
                loop: false,
            },
            function onPlayerReady() {
                this.volume(0.5);
                this.on('ended', toPlan);

                this.on('fullscreenchange', () => {
                    const skipButton = document.querySelector('.skip-intro');
                    const muteButton = document.getElementById('mute');
                    if (this.isFullscreen()) {
                        document.getElementById('videoIntro_html5_api').after(skipButton);
                        document.getElementById('videoIntro_html5_api').after(muteButton);
                    } else {
                        document.getElementById('videoIntro').before(skipButton);
                        document.getElementById('videoIntro').before(muteButton);
                    }
                });
            }
        );

        player.current.src({
            src: Config.prefix + '/video/' + (isMobile() ? 'mobile' : '') + '/BL_Opener_H264_WEB.mp4',
            type: "video/mp4"
        });

        if (typeof window !== `undefined`) {
            window.addEventListener('resize', () => {
                setPlayerSize(player.current);
            });
        }

    }, []);

    const toggleMute = () => {
        player.current.muted(!player.current.muted());
        setMuteClassName(player.current.muted() ? 'mute' : 'unmute');
    }

    const toPlan = (event) => {
        event.preventDefault();
        navigate('/plan/');
    }

    return (
        <div id="video-wrap" className='intro'>

            {/* eslint-disable jsx-a11y/media-has-caption */}
            <video id="videoIntro" className="video-intro video-js" muted playsInline autoPlay='play' controls/>
            {/* eslint-enable jsx-a11y/media-has-caption */}

            <div id="mute" className={muteClassName}
                 role="button"
                 tabIndex="0"
                 onClick={toggleMute}
                 onKeyPress={toggleMute}>&nbsp;</div>

            <Link className="skip-intro" to="#" onClick={toPlan}>Intro überspringen</Link>
            {/*<button className="skip-intro" onClick={skipIntro}>Intro überspringen</button>*/}
        </div>
    );
}

/**
 *
 */
const showAllPreviews = () => {
    setTimeout(() => {

        let bottom = 0;
        let colIndex = 0;

        const previews = Array.from(document.querySelectorAll('#videoBox .blt-overlay-preview'));

        previews.reverse().forEach((el) => {
            el.classList.add('show-all');
            el.removeAttribute('style');
            el.style.bottom = bottom + 'px';
            el.style.left = '-620px';
            el.classList.remove('vjs-hidden');
            el.classList.remove('vjs-overlay-bottom-left');

            const elRect = el.getBoundingClientRect();
            if (elRect.top < elRect.height) {
                colIndex++;
                bottom = 0;
                el.style.bottom = bottom + 'px';
            }
            el.setAttribute('data-colindex', colIndex);

            bottom += 70 + el.getBoundingClientRect().height - 100;
        });

        const el = document.querySelector('#videoBox .blt-overlay-preview .overlay-link');
        if (el !== null) {
            const elRect = el.getBoundingClientRect();

            setTimeout(() => {
                document.querySelectorAll('#videoBox .blt-overlay-preview').forEach((el, index) => {
                    setTimeout(() => {
                        let colIndex = parseInt(el.getAttribute('data-colindex'));
                        colIndex = isNaN(colIndex) ? 0 : colIndex;
                        el.style.left = (colIndex * (elRect.width + 20)) + 'px';
                    }, 100 * (index + 1));
                });
            });
        }
    }, 500);
}

/**
 *
 */
const replay = () => {
    document.querySelectorAll('.show-all').forEach((el) => {
        el.classList.remove('show-all');
        el.classList.add('vjs-hidden');
        el.classList.add('vjs-overlay-bottom-left');
        el.removeAttribute('style');
    });

    if (audioPlayer !== undefined) {
        audioPlayer.pause();
    }
}

/**
 *
 */
const stop = () => {
    if (videoPlayer !== undefined) {
        if (videoPlayer.isFullscreen()) {
            videoPlayer.exitFullscreen();
        }
        videoPlayer.pause();
        currentOverlayPreviewId = null;
        audioPlayer.play();
    }
}

/**
 *
 */
const pause = () => {
    if (videoPlayer !== undefined && !videoPlayer.paused()) {
        videoPlayer.pause();
    }
    if (audioPlayer !== undefined) {
        audioPlayer.play();
    }
}

/**
 *
 */
const play = () => {
    if (videoPlayer !== undefined && videoPlayer.paused()) {
        videoPlayer.play();
    }
    if (audioPlayer !== undefined) {
        audioPlayer.pause();
    }
}

export {Container, Intro, setOverlays, play, stop, setAllImages}
